<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
              <ion-menu-button></ion-menu-button>
              <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              <ion-title>Add New Tariff</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
         <AddNewTariff />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import { add } from 'ionicons/icons';
import AddNewTariff from "@/components/admin/AddNewTariff.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar, IonBackButton } from '@ionic/vue';

export default defineComponent({
  name:  'addNewTariff',
  components: {
    AddNewTariff, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent, IonBackButton
  },
  data() {
    return {
      add
    }
  },
  methods: {
    addNewCPO() {
      this.$router.push("addNewCorporate"); 
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    },
  }
})
</script>